import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    reviewers: [],
    employees: [],
  },
  getters: {
    reviewers: state => state.reviewers,
    employees: state => state.employees,
  },
  mutations: {
    SET_REVIEWERS: (state, data) => { state.reviewers = data },
    SET_EMPLOYEES: (state, data) => { state.employees = data },
  },
  actions: {
    async getReviewers({ commit }, params) {
      try {
        const response = await axios.get('uni/researchReviewers', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_REVIEWERS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getEmployeesByOrganizationId({ commit }) {
      try {
        const response = await axios.get('uni/employees/getAllByOrganizationId')
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_EMPLOYEES', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async createReviewers({ commit }, params) {
      try {
        const response = await axios.post('uni/researchReviewers', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateReviewer({ commit }, param) {
      try {
        const response = await axios.put(`uni/researchReviewers/${param.id}`, param)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteReviewer({ commit }, id) {
      try {
        const response = await axios.delete(`uni/researchReviewers/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
